import { inject, Injectable } from '@angular/core';
import { MainService } from '@app/services/main.service';

@Injectable({ providedIn: 'root' })
export class LoaderService {
    private _loading: boolean = false;
    private loaderDebounce: any;

    private readonly mainService = inject(MainService);

    loading(): boolean {
        return this._loading;
    }

    public loader(state: boolean = false, debounceTime?: number) {
        clearTimeout(this.loaderDebounce);
        if (debounceTime) {
            this.loaderDebounce = setTimeout(() => {
                this.mainService.showLoader = state;
            }, debounceTime);
        } else {
            this.mainService.showLoader = state;
        }
    }
}
